<template>
    <ServiceComplaint ref="serviceComplaintRef" />
</template>

<script>
import ServiceComplaint from '@/components/home/ServiceComplaint.vue'

var wxServiceDialog

export default {
    name: 'WxServiceNew',
    components: {
        ServiceComplaint
    },
    mounted() {
        this.video_Tutorial_btn()
        // 设置悬浮入口的初始位置
        this.setWxServiceBtnPosition()
    },
    methods: {
        video_Tutorial_btn() {
            var that = this
            var menuDisplay = false
            var flag = true
            var timer
            var html = []
            html.push(' <div class="float-btn-wx-new">')
            html.push('<div class="float-btn-wx-new-img" />')
            html.push('<div class="mini-menu-Overall-wx ">')
            html.push(
                '<div class="mini-menu-Overall-item-wx" id="wx-customer-service"><img style="width: 20px;height: 20px; margin: 4px;" src="https://imagecdn.ymm56.com/ymmfile/static/image/wxServiceIcon.png" /><div style="width: 100px">官方客服快速服务</div></div>'
            )
            html.push(
                '<div class="mini-menu-Overall-item-wx" id="wx-service-complaint" ><img style="width: 15px; height: 17px; margin: 4px;" src="https://imagecdn.ymm56.com/ymmfile/static/image/serviceComplaintIcon.png" /><div style="width: 100px">服务投诉</div></div>'
            )
            html.push('</div>')
            html.push('</div>')

            $('body').append(html.join(''))

            // 服务投诉曝光埋点
            window.lib && window.lib.track.view('enter_complaint2', 'Main', {
                pageName: 'lanqiao_saas_home'
            })
            //  企微官方客服快速服务
            $('#wx-customer-service').click(function (event) {
                window.event ? (window.event.cancelBubble = true) : event.stopPropagation()
                that.openWxService()
            })

            // 服务投诉
            $('#wx-service-complaint').click(function (event) {
                window.event ? (window.event.cancelBubble = true) : event.stopPropagation()
                that.openServiceComplaint()
            })

            iconBorder()

            // 切换图片
            that.setImgPerFiveSecond()

            //图标移动方法
            $('.float-btn-wx-new').ligerDrag &&
                $('.float-btn-wx-new').ligerDrag({
                    proxy: false,
                    clickDelay: 200,

                    //开始移动事件
                    onStartDrag: function () {
                        //移动状态下不弹出菜单组件
                        flag = false
                        $('.mini-menu-Overall-wx').hide()
                    },

                    //移动结束事件
                    onStopDrag: function (start, end) {
                        var rightDistance = document.documentElement.clientWidth
                        var btn = $('.float-btn-wx-new').offset().left
                        var btnTop = $('.float-btn-wx-new').offset().top
                        var width = $('.float-btn-wx-new').width()

                        //移动结束后判断是否靠浏览器右边边界
                        if (btn + width + 5 >= rightDistance) {
                            //靠近边界
                            $('.float-btn-wx-new').css({
                                left: rightDistance - 40 * 0.6,
                                opacity: '.6'
                            })
                            menuDisplay = false
                            that.setAllFloatPosition({
                                clientX: rightDistance - 40 * 0.6,
                                clientY: end.clientY
                            })
                        } else {
                            //移出边界了,图标让正常使用
                            $('.float-btn-wx-new').css({
                                opacity: '1'
                            })
                            menuDisplay = true
                            flag = true
                            that.setAllFloatPosition({
                                clientX: btn,
                                clientY: btnTop,
                            })
                        }
                    }
                })

            //鼠标移入图标事件
            $('.float-btn-wx-new').mouseover(function () {
                if (menuDisplay && flag) {
                    //0.5秒后弹出菜单组件
                    timer = setTimeout(function () {
                        //移动状态下不弹出菜单组件
                        if (!flag) {
                            clearTimeout(timer)
                            return
                        }
                        $('.mini-menu-Overall-wx').show()
                        $('.mini-menu-Overall-wx').css({ top: -22, left: -155 })
                    }, 200)
                }

                // 只有在初始位置的时候，才会有这个弹出的动作
                const wxServiceEntrancePosition = JSON.parse(top.window.sessionStorage.getItem('wxServiceEntrancePosition'))
                // 如果是从靠右的初始位置移入，有个弹出的动作
                if (!menuDisplay) {
                        var rightDistance = document.documentElement.clientWidth - 50
                    if (!wxServiceEntrancePosition || rightDistance <  wxServiceEntrancePosition.left) {
                        $('.float-btn-wx-new').css({
                            left: rightDistance,
                            opacity: '1'
                        })
                    } else {
                        $('.float-btn-wx-new').css({
                            opacity: '1'
                        })
                    }

                    menuDisplay = true
                    flag = true
                }
            })

            // 鼠标移开图标事件
            $('.float-btn-wx-new').mouseleave(function () {
                if (menuDisplay && flag) {
                    clearTimeout(timer)
                }
            })

            //窗口大小改变
            $(window).resize(function () {
                winChange()
            })

            // 点击其它位置隐藏弹出来的选择列表
            $(window).click(function () {
                $('.mini-menu-Overall-wx').hide()
            })

            //浏览器窗口大小改变后的回调
            function winChange() {
                var rightDistanceR = document.documentElement.clientWidth
                var btnR = $('.float-btn-wx-new').offset().left
                if (btnR + 40 >= rightDistanceR) {
                    //贴近右边浏览器边界时

                    $('.float-btn-wx-new').css({
                        left: rightDistanceR - 40 * 0.6,
                        opacity: '.6'
                    })
                    menuDisplay = false

                } else if (btnR > rightDistanceR) {
                    //图标移动距离大于浏览器大小时
                    $('.float-btn-wx-new').css({
                        left: rightDistanceR - 40 * 0.6,
                        opacity: '.6'
                    })
                    menuDisplay = false
                } else if (!menuDisplay) {
                    //图标没被移动出来，让图标一直贴着
                    // 判断是否是初始化，如果是初始化情况，则放置在初始化的位置(开多个tab的刷新的时候，切换tab会触发该事件)
                    const wxServiceEntrancePosition = JSON.parse(top.window.sessionStorage.getItem('wxServiceEntrancePosition'))
                    if (wxServiceEntrancePosition && wxServiceEntrancePosition.left < rightDistanceR-50) {
                        $('.float-btn-wx-new').css({
                            left: wxServiceEntrancePosition.left,
                            top: wxServiceEntrancePosition.top,
                            opacity: '.6'
                        })
                    } else {
                        $('.float-btn-wx-new').css({
                            left: rightDistanceR - 40 * 0.6,
                            opacity: '.6'
                        })
                    }
                    menuDisplay = false
                } else {
                    //图标已被移动出来
                    $('.float-btn-wx-new').css({
                        opacity: '1'
                    })
                    //menuDisplay ，图标移动出来后，停留在图标上可以让图标弹出菜单组件
                    menuDisplay = true
                }
            }

            //双击弹出菜单栏
            $('.float-btn-wx-new').dblclick(function (event) {
                window.event ? (window.event.cancelBubble = true) : event.stopPropagation()
                if (menuDisplay) {
                    $('.mini-menu-Overall-wx').show()
                }
            })

            //隐藏图标函数
            function iconBorder() {
                var width = $('.float-btn-wx-new').width()
                $('.float-btn-wx-new').css({
                    right: width * -0.4,
                    opacity: '.6'
                })
            }
        },

        // 服务投诉
        openServiceComplaint() {
            // 服务投诉点击埋点
            window.lib && window.lib.track.tap('enter_complaint2', 'Main', {
                pageName: 'lanqiao_saas_home'
            })
            // 判断企微弹窗存在的话先关闭
            if (wxServiceDialog) {
                wxServiceDialog.close()
                wxServiceDialog = null
            }

            this.$refs.serviceComplaintRef.show()
            $('.mini-menu-Overall-wx').hide()
        },

        // 企微客服
        openWxService() {
            // 判断如果服务投诉弹窗开启的话，先关闭
            const serviceComplaintRef = this.$refs.serviceComplaintRef
            if (serviceComplaintRef.dialogVisible) {
                serviceComplaintRef.handleClose()
            }
            // 避免重复打开弹窗
            if (!wxServiceDialog) {
                var wxDialogTitle =
                    JSON.parse(localStorage.getItem('configMap') || '{}') &&
                    JSON.parse(localStorage.getItem('configMap') || '{}').quickClienteleService
                    window.lib && window.lib.track.tap('click_enter_WChat3', 'Main', {
                        pageName: 'lanqiao_saas_home'
                    })

                wxServiceDialog = $.ligerDialog.open({
                    title: wxDialogTitle.title,
                    modal: false,
                    width: 514,
                    height: 517,
                    url: '/weCom/weCom',
                    name: 'weCom',
                    closeClickName: function () {
                        wxServiceDialog = null
                    }
                })
                $('.mini-menu-Overall-wx').hide()
            }
        },

                // 手动修改所有的位置
        setWxServiceBtnPosition() {
            const wxServiceEntrancePosition = JSON.parse(top.window.sessionStorage.getItem('wxServiceEntrancePosition'))
            if (wxServiceEntrancePosition) {
                $('.float-btn-wx-new').css({
                    left: wxServiceEntrancePosition.left,
                    top: wxServiceEntrancePosition.top
                })
            }
        },

        // 设置其他iframe中元素位置
        setAllFloatPosition(end) {
            top.window.sessionStorage.setItem(
                'wxServiceEntrancePosition',
                JSON.stringify({
                    left: end.clientX,
                    top: end.clientY
                })
            )
            var allIframe = top.document.getElementsByTagName('iframe')
            for (let index = 0; index < allIframe.length; index++) {
                const element =
                    allIframe[index] &&
                    allIframe[index].contentDocument &&
                    allIframe[index].contentDocument.getElementsByClassName('float-btn-wx-new') &&
                    allIframe[index].contentDocument.getElementsByClassName('float-btn-wx-new')[0]
                if (element && end) {
                    $(element).css({
                        left: end.clientX,
                        top: end.clientY
                    })
                }
            }
        },

        // 每隔5s修改图片
        setImgPerFiveSecond() {
            const imgInit = 'url("https://imagecdn.ymm56.com/ymmfile/static/resource/beeb0dc7-89e0-47a8-bf58-86c26a68dc47.png")'
            const imgSwitch = 'url("https://imagecdn.ymm56.com/ymmfile/static/resource/4c3e70bb-26c3-4cd7-a7a2-148fbca3f77a.png")'
            setInterval(() => {
                const floatImgBackground = $('.float-btn-wx-new-img').css('background-image')
                if (floatImgBackground === imgSwitch) {
                    $('.float-btn-wx-new-img').css({
                        'background-image': imgInit
                    })
                }
                if (floatImgBackground === imgInit) {
                    $('.float-btn-wx-new-img').css({
                        'background-image': imgSwitch
                    })
                }
            }, 5000)
        },
    }
}
</script>

<style>
.float-btn-wx-new {
    width: 36px;
    height: 36px;
    font-size: 30px !important;
    cursor: pointer !important;
    position: fixed;
    top: 60%;
    right: 0;
    z-index: 10086;
    color: #03a9f4;
    text-align: center !important;
    line-height: 36px !important;
    /* background: rgb(255 255 255); */
    /* border-radius: 50%; */
    overflow: visible;
}
.mini-menu-Overall-wx {
    position: absolute;
    left: 0px;
    top: 0px;
    box-shadow: rgba(0, 0, 0, 0.5) 2px 2px 8px 0px;
    z-index: 2147483647;
    display: none;
    background: rgb(253, 253, 253);
    border-width: 2px;
    border-style: solid;
    border-color: #03a9f4;
    border-image: initial;
    padding: 5px;
    border-radius: 3px;
    font-size: 12px !important;
    z-index: 10086;
}

.mini-menu-Overall-wx:after {
    content: '';
    width: 10px;
    height: 10px;
    background: #fdfdfd;
    position: absolute;
    top: 50%;
    margin-top: -5px;
    left: 135px;
    transform: rotate(-45deg);
    border-bottom: 2.4px solid #03a9f4;
    border-right: 2.4px solid #03a9f4;
    border-top-left-radius: 6px;
}

.mini-menu-Overall-item-wx {
    color: #000;
    line-height: 30px;
    border-radius: 3px;
    width: 130px;
    text-align: center;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.mini-menu-Overall-item-wx + .mini-menu-Overall-item-wx {
    border-top: 1px dashed #ddd;
}

.mini-menu-Overall-item-wx:hover {
    color: #2f4554;
    box-shadow: 0px -1px 0px 0px #03a9f4 inset, 0px 1px 0px 0px #03a9f4 inset;
}

/* 企微浮动入口 */
.float-btn-wx-new-img {
    display: inline-block;
    width: 36px;
    height: 36px;
    background-size: 100% 100%;
    background-image: url(https://imagecdn.ymm56.com/ymmfile/static/resource/beeb0dc7-89e0-47a8-bf58-86c26a68dc47.png);
}

</style>
